import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import styled from 'styled-components'

export const Styled2LAButtonLink = styled(ButtonLink)`
    background-color: transparent;
`
